<template>
  <v-app id="app">
    <NavBar v-if="(isAuth || !isExpired) && (!isRedirectStatement && !isQue)" />
    <BreadCrumb
      v-if="(isAuth || !isExpired) && (!isRedirectStatement && !isQue)"
    />
    <Menu v-if="!isRedirectStatement && !isQue" />
    <div
      :class="
        (isAuth || !isExpired) && (!isRedirectStatement && !isQue)
          ? 'main-content'
          : 'login'
      "
    >
      <router-view />
    </div>
    <PreLoader />
    <v-dialog v-model="showPopup" max-width="600px">
      <v-card tile>
        <v-toolbar flat dense color="red darken-3">
          <v-icon color="red lighten-5">fa-exclamation-circle</v-icon>
          <v-toolbar-title style="color: #ffebee;"></v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="showPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark color="red accent-1">
          <br />
          <span style="color: red;" v-html="popupText">{{ popupText }}</span>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import UserProvider from "@/services/user_provider";
import NavBar from "@/components/NavBar.vue";
import BreadCrumb from "@/components/BreadCrumb.vue";
import Menu from "@/components/Menu.vue";
import PreLoader from "@/components/PreLoader.vue";

const userProvider = new UserProvider();

export default {
  components: {
    NavBar,
    BreadCrumb,
    Menu,
    PreLoader
  },
  computed: {
    ...mapGetters("application", {
      isAuth: "isAuth",
      isExpired: "isExpired",
      isShowLoad: "isShowLoad",
      isError: "isError",
      getErrorText: "getErrorText",
      appInfo: "getUserInfo",
      token: "getToken",
      isRedirectStatement: "isRedirectStatement",
      userId: "getUserId",
      getReload: "getReload",
      sessionGuid: "getSessionGuid",
      seq: "getSeq",
      isQue: "isQue",
      mfuUserId: "getMfuUserId"
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    }
  },
  data() {
    return {
      showPopup: false,
      popupText: "",
      intervalKeepAlive: {},
      intervalId: 0
    };
  },
  onIdle() {
    if (this.$router.currentRoute.name !== "Login") {
      this.clearToken();
      this.$router.push("/redirecthome");
    } else {
      console.log(this.$router.currentRoute.name);
    }
  },
  created() {
    let r = 0;
    const tReload = this.getReload;
    console.log("getReload app created", tReload);
    if (!Number.isInteger(tReload)) {
      const dt = new Date();
      const dtReload = tReload ? new Date(tReload) : new Date();
      var diff = (dt.getTime() - dtReload.getTime()) / 1000;
      diff /= 60;
      const dtDiff = Math.abs(Math.round(diff));
      if (dtDiff > 1) {
        r = -1;
      }
    }
    this.setReload(r);
    console.log("setReloaded app created", tReload);
    console.log("setReloaded app created 0", r);
    if (r >= 0 || this.$route.name === "DataTransfer") {
      console.log("setReloaded app created 1", r);
      window.addEventListener("beforeunload", this.onUnload);
    } else {
      console.log("setReloaded app created 2", r);
      this.clearToken();
      this.$router.push("/redirecthome");
    }
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.onUnload);
  },
  mounted() {
    console.log("token intervalId", this.intervalId);
    const set = this.setToken;
    for (var i = 1; i <= this.intervalId; i++) {
      window.clearInterval(i);
    }
    this.intervalId = setInterval(async function() {
      const ls = JSON.parse(localStorage.getItem("mfu-er-app"));
      const token = ls.application.token;
      if (token && token != "") {
        const res = await userProvider.keepalive(token);
        if (res.status == 200) {
          set(res.data.token);
        }
      }
    }, 60000 * 20);
  },
  methods: {
    ...mapActions("application", [
      "logout",
      "setCurrentUserAsync",
      "setErrorPopup",
      "setToken",
      "clearToken",
      "setReload",
      "setSessionGuid",
      "setSeq"
    ]),
    onUnload() {
      if (this.token != "") {
        // let url = process.env.VUE_APP_API_ENDPOINT;
        // fetch(url + "reg/enroll/killsession", {
        //   method: "DELETE",
        //   headers: {
        //     Accept: "application/json",
        //     "Content-Type": "application/json",
        //     Authorization: `Bearer ${this.token}`
        //   },
        //   body: JSON.stringify({
        //     sessionguid: this.sessionGuid
        //   }),
        //   keepalive: true
        // });
        // this.setSessionGuid(false);
        // this.setSeq(false);
      }

      const tReload = this.getReload;
      if (Number.isInteger(tReload) && tReload == -1) {
        this.setReload(-1);
      } else {
        this.setReload(1);
      }
    }
  },
  watch: {
    isExpired(val) {
      if (val) {
        this.logout();
      }
    },
    isAuth(val) {
      if (!val) {
        this.logout();
      }
    },
    async currentLang(val) {
      if (this.userId > 0) {
        await this.setCurrentUserAsync({
          token: this.token,
          request: {
            userid: this.mfuUserId,
            lang: val
          }
        });
      }
    },
    isError(val) {
      this.showPopup = val;
    },
    showPopup(val) {
      this.setErrorPopup(val);
    },
    getErrorText(val) {
      this.popupText = val;
    }
  }
};
</script>

<style scoped>
.login {
  margin: auto auto;
}
body.sidebar-mini .main-content,
body.sidebar-mini .main-footer {
  padding-left: 0px !important;
}
body.sidebar-mini .navbar,
body.sidebar-mini .breadcrumb-navbar {
  left: 0px !important;
}
</style>
